<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M7.49999 7.50247C7.49955 7.35459 7.53846 7.20924 7.61275 7.08136C7.68704 6.95349 7.79402 6.84768 7.92271 6.77481C8.0514 6.70194 8.19716 6.66463 8.34504 6.66671C8.49291 6.66879 8.63757 6.71018 8.76416 6.78664L12.9283 9.28414C13.0523 9.35803 13.155 9.46285 13.2262 9.58833C13.2975 9.71381 13.335 9.85565 13.335 9.99997C13.335 10.1443 13.2975 10.2861 13.2262 10.4116C13.155 10.5371 13.0523 10.6419 12.9283 10.7158L8.76416 13.2133C8.63751 13.2898 8.49277 13.3312 8.34483 13.3332C8.19688 13.3353 8.05106 13.2979 7.92234 13.2249C7.79363 13.152 7.68666 13.046 7.61243 12.918C7.53821 12.79 7.4994 12.6446 7.49999 12.4966V7.50247Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10 18.3333C14.6024 18.3333 18.3333 14.6023 18.3333 9.99996C18.3333 5.39759 14.6024 1.66663 10 1.66663C5.39763 1.66663 1.66667 5.39759 1.66667 9.99996C1.66667 14.6023 5.39763 18.3333 10 18.3333Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconPlayCircle',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
